<template>
  <div class="gray-back" style="padding:.2rem 0 1rem 0;min-height: 100%">
    <van-form
        @submit="onSubmit"
        @failed="onFailed"
    >
      <van-cell-group>
        <van-field
            readonly
            clickable
            :value="formData.extra_saiqu.length ? formData.extra_saiqu[0].name : ''"
            autosize
            type="textarea"
            input-align="right"
            label="选择赛区"
            placeholder="选择执裁的赛区"
            @click="showSaiquPicker = true"
        />
        <SaiquPicker
            :show="showSaiquPicker"
            :limit="1"
            :value="formData.extra_saiqu"
            @onChange="onSaiquChange"
            @onClose="showSaiquPicker=false"
            :defaultValue="formData.extra_saiqu"
            @onConfirm="onSaiquConfirm"
        ></SaiquPicker>


        <van-field
            v-model="formData.caipan_admin_name"
            :rules="[{ required: true, message: '请输入裁判长姓名' }]"
            error-message-align="right"
            label="裁判长姓名"
            input-align="right"
            clearable
            placeholder="请输入裁判长姓名"
        />

        <van-field
            v-model="formData.name"
            :rules="[{ required: true, message: '请输入姓名' }]"
            error-message-align="right"
            label="执裁裁判名称"
            input-align="right"
            clearable
            placeholder="请输入姓名"
        />



        <van-field
            readonly
            clickable
            label="日期"
            input-align="right"
            error-message-align="right"
            placeholder="请选择日期"
            v-model="formData.date"
            :rules="[{ required: true, message: '请选择日期' }]"
            @click="showDate = true"/>
        <van-popup v-model="showDate" position="bottom">

          <van-datetime-picker
              type="date"
              title="选择年月日"
              v-model="currentDate"
              :min-date="minDate"
              :max-date="maxDate"
              @confirm="onDateConfirm"
              @cancel="showDate=false"
          />
        </van-popup>

        <van-cell title="执裁记录照片" :value="formData.pic.length+'/9'">
        </van-cell>

        <div class="row">
          <PicUploader :fileList="formData.pic" :limit="9"
                       :name="'pic'"></PicUploader>
        </div>


      </van-cell-group>

      <div style="height: 100px"></div>

      <div class="savebtn">
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">
          提交申请
        </van-button>
      </div>
    </van-form>

    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>

  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}


.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import LoginDialog from "@/components/LoginDialog.vue";
import SaiquPicker from '@/components/picker/SaiquPicker.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'SaiScoreCaipanApply',
  components: {
    PicUploader, LoginDialog, SaiquPicker
  },
  data: function () {
    return {
      validator,
      loginShow: false,
      showDate: false,
      showSaiquPicker: false,
      saveLoading: false,
      showArea: false,
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      areaList: {},
      areaValue: '',
      submitType: '',
      formData: {
        id: 0,
        saiqu: '',
        caipan_admin_name: '',
        name: '',
        date: '',
        pic: [],
        extra_saiqu: [],
      },
    }
  },
  filters: {},
  mounted() {
    document.title = "执裁记录申请";
    let that = this;
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.getUserDetail();
      this.loginShow = false;
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },
    onQuestion() {
      console.log('onQuestion')
    },
    onDateConfirm(date){
      console.log('onDateConfirm',date);
      this.showDate = false;
      this.formData.date =  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;


      for (let field in that.formData) {

        if (!this.formData.saiqu) {
          Toast('请选择赛区');
          return
        }

        if (!this.formData.pic.length) {
          Toast('请上传执裁记录照片');
          return
        }
      }
      that.saveLoading = true;

      that.$api.post('/api/sai/scoreCaipanApply', that.formData, (res) => {
        that.saveLoading = false;
        Toast.success('申请成功');
        setTimeout(() => {
          rbLink({
            name: "UserSearchCaipan",
          }, 'back')
        }, 200)
      }, (res) => {

        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink(
                {
                  name: "login",
                  query: {}
                },
                "replace"
            );
            return false;
          } else {
            // Toast(res.msg);
            this.loginShow = true;
          }
        }
        Toast(res.msg);
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    onSaiquChange(values) {
      console.log('onSaiquChange', values)
      this.formData.saiqu = values[0].id;
      this.formData.extra_saiqu = [...values];
    },
    onSaiquConfirm(values) {
      console.log('onJianduConfirm', values)
      this.showSaiquPicker = false;
      this.formData.saiqu = values[0].id;
      this.formData.extra_saiqu = [...values];
    },

    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },

  }
}
</script>



// WEBPACK FOOTER //
// SaiScoreCaipanApply.vue?2e564364